import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';

import { provideTranslateService } from '@ngx-translate/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './auth.interceptor';
import { BroadcastService } from './services/broadcast.service';
import { TrademaxAPIService } from './trademaxapi.service';
import { UsedCarsService } from './services/used-cars.service';
import { CustomTrackingService } from './custom-tracking.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideTranslateService({
      defaultLanguage: 'en',
      useDefaultLang: true,
      //isolate: true,
      extend: true,
    }),
    BroadcastService,
    TrademaxAPIService,
    UsedCarsService,
    CustomTrackingService,
  ].filter((el) => el !== null), // Filter out null values
};
